import './SearchImage.scss'
import {useEffect, useRef, useState} from "react";
import { Button, Spinner, Card, CardPreview, Image as FImage } from "@fluentui/react-components";
import { useAuth } from "../../auth/AuthProvider";
import { searchImage } from '../../services/search-image.service';
import {
  AddCircle32Filled,  
  DatabaseSearch32Regular,  
} from "@fluentui/react-icons";
import SearchImageResult from './SearchImageResult/SearchImageResult';

function SearchImage()
{
    const [imageSelected, setimageSelected] = useState(null);
    const [loading, setLoading] = useState(false);
    const {logout, user} = useAuth();    
    const [previewUrl, setPreviewUrl] = useState("");
    const [searchHappened, setSearchHappened] = useState(false);
    const [results, setResults] = useState([]); 
    const fileInputRef = useRef(null);
    const objectUrlRef = useRef(null);

    async function SearchByImage()
    {
        try
        {
            let email = user;
            if(imageSelected)
            {
                setLoading(true);                
                const data = await searchImage(
                    email, imageSelected, {timeoutMs: 60000});
                const imgs = (data?.images ?? []).map((img) => ({
                    id: img.id,
                    name: img.name,
                    // API already returns a full data URL; if not, build it:
                    src: img.data?.startsWith("data:")
                    ? img.data
                    : `data:${img.contentType || "image/*"};base64,${img.data}`,
                }));
                setResults(imgs);
            }
        }
        catch(err)
        {
            if(err.status === 401 || err.status === 403)
                logout();                
            //TODO display notification error message
            setLoading(false);
            setResults([]);
        }
        finally
        {
            setSearchHappened(true);
            setLoading(false);
        }        
    }

    function onFileChange(e) {
        const file = e.target.files?.[0];
        if (!file) return;
        setResults([]);
        setSearchHappened(false);
        // revoke previous URL (avoid memory leaks)
        if (objectUrlRef.current) 
            URL.revokeObjectURL(objectUrlRef.current);

        const url = URL.createObjectURL(file);
        objectUrlRef.current = url;
        setPreviewUrl(url);        
        setimageSelected(fileInputRef?.current?.files[0]);
    }

    function onClear() {
        if (objectUrlRef.current) URL.revokeObjectURL(objectUrlRef.current);
        objectUrlRef.current = null;
        setPreviewUrl("");        
        setResults([]);
        if (fileInputRef.current) 
            fileInputRef.current.value = "";
    }

    useEffect(() => {
        return () => {
        if (objectUrlRef.current) URL.revokeObjectURL(objectUrlRef.current);
        };
    }, []);

    function onPickClick() 
    {        
        fileInputRef.current?.click();
    }

    return (
        <div>
            <br/>
            <div className='d-flex justify-content-center'>
                <input 
                ref={fileInputRef}
                type='file'
                accept='image/*'
                onChange={onFileChange}
                style={{ display: "none" }}
                />
                <div className='row'>
                    <div className='col-md-12'>
                        <Button appearance="primary" onClick={onPickClick} shape="circular" icon={<AddCircle32Filled/>} iconPosition="after">
                            Pick from gallery
                        </Button> 
                    </div>
                </div>
            </div>
            <br/>
            <div className='container d-flex justify-content-center'>
                <div className='row'>
                    <div className='col-md-12'>
                        <div>
                            {previewUrl && (
                            <Card>
                            <CardPreview>
                                <FImage src={previewUrl} alt="Selected" fit="cover" style={{
                                    maxWidth: "512px",
                                    maxHeight: "300px"
                                    }}/>                                
                            </CardPreview>
                            </Card>
                            )}
                        </div>                        
                    </div>                    
                </div>
            </div>
            <br/>
            {imageSelected && <div className='container d-flex justify-content-center'>
                <div className='row'>
                    <div className='col-md-12'>
                        <Button appearance="primary" onClick={SearchByImage} shape="circular" icon={<DatabaseSearch32Regular/>} iconPosition="after">
                            Check Person
                        </Button>
                    </div>
                </div>
            </div>}
            <br/>
            <div className='container d-flex justify-content-center'>
                <div className='row'>
                    <div className='col-md-12'>
                        {loading && <Spinner labelPosition='before' label="Searching records..." />}
                    </div>
                </div>
            </div>
            <SearchImageResult 
                resultlist={results}
                searchTriggered={searchHappened}
            />           
        </div>
    );
}

export default SearchImage;
